import { render, staticRenderFns } from "./TradeForm.vue?vue&type=template&id=75da285e&scoped=true"
import script from "./TradeForm.vue?vue&type=script&lang=js"
export * from "./TradeForm.vue?vue&type=script&lang=js"
import style0 from "./TradeForm.vue?vue&type=style&index=0&id=75da285e&prod&lang=scss&scoped=true"
import style1 from "./TradeForm.vue?vue&type=style&index=1&id=75da285e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75da285e",
  null
  
)

export default component.exports